import { render, staticRenderFns } from "./OrganismServerPolicy.vue?vue&type=template&id=d9ae72f0&scoped=true&"
import script from "./OrganismServerPolicy.vue?vue&type=script&lang=js&"
export * from "./OrganismServerPolicy.vue?vue&type=script&lang=js&"
import style0 from "./OrganismServerPolicy.vue?vue&type=style&index=0&id=d9ae72f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ae72f0",
  null
  
)

export default component.exports